import Icon from 'ui/atoms/Icon/Icon';
import FeedBackUser from 'core/modules/components/general/FeedBackUser';
import PropTypes from 'prop-types';
import React from 'react';
import useMaterialComments from '../useMaterialComments';

function MaterialPreviewMessages({ courseGuid, courseMessageGuid, isReadOnly, t }) {
  const { comments, currentUser, loading, onDeleteComment, onEditComment, onPublishComment } = useMaterialComments({
    courseGuid,
    courseMessageGuid,
    isReadOnly,
    t,
  });

  return (
    <div className="material-preview-messages">
      {!comments.length && (
        <div className="d-flex flex-column align-items-center mt-4">
          <Icon name="comments" size="xxl" />
          <span className="not-comments mt-3">{t('tasks:There are no comments')}</span>
        </div>
      )}
      <FeedBackUser
        comments={comments}
        currentUser={currentUser}
        disabled={isReadOnly}
        guid={courseMessageGuid}
        loading={loading}
        onPublishComment={onPublishComment}
        openProp
        onEditCommentDialog={onEditComment}
        onDeleteCommentDialog={onDeleteComment}
      />
    </div>
  );
}

MaterialPreviewMessages.propTypes = {
  courseGuid: PropTypes.string.isRequired,
  courseMessageGuid: PropTypes.string.isRequired,
  isReadOnly: PropTypes.bool,
  material: PropTypes.object,
  t: PropTypes.func.isRequired,
};

export default MaterialPreviewMessages;
